<template>
  <div :style="$cmsStyles('c_39e2dc770204')" class="media-container">
    <tools-bar ref="toolsBar"></tools-bar>
    <main class="media-content">
      <article class="service-wrapper">
        <section v-show="$cms('c_39e2dc770204', 'f_0001', true)" class="banner-wrapper"></section>
        <div class="common-content-wrapper content-wrapper">
          <section v-show="$cms('c_39e2dc770204', 'f_0002', true)" class="box-1">
            <header class="box-header">
              <h1 class="box-header-title">{{ $cms('c_39e2dc770204', 'f_0003', "DiaryLuck品牌介绍") }}</h1>
              <p class="box-header-desc">{{ $cms('c_39e2dc770204', 'f_0004', "Brand Introduction") }}</p>
            </header>
            <div class="box-content">
              <p class="desc">{{ $cms('c_39e2dc770204', 'f_0005', "当生命平衡被悄然打破") }}<br />{{ $cms('c_39e2dc770204', 'f_0006', "DiaryLuck以科学为语言") }}<br />{{ $cms('c_39e2dc770204', 'f_0007', "深入细胞层面，重建健康脉络") }}<br />{{ $cms('c_39e2dc770204', 'f_0008', "唤醒生命本应有的状态：有序、充盈、从容") }}<br /><br />{{ $cms('c_39e2dc770204', 'f_0009', "源自美国，遍及全球") }}<br />{{ $cms('c_39e2dc770204', 'f_0010', "我们始终只坚持一件事") }}<br />{{ $cms('c_39e2dc770204', 'f_0011', "让稳态新生，让生命复衡") }}</p>
            </div>
          </section>

          <section v-show="$cms('c_39e2dc770204', 'f_0012', true)" class="box-2">
            <div class="box-content">
              <div class="box-left">
                <header class="title-box">
                  <img class="title-icon" :src="$cms('c_39e2dc770204', 'f_0013', &quot;https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250821101319230000944.17557423989151475.png&quot;)" :alt="$cms('c_39e2dc770204', 'f_0014', &quot;DiaryLuck品牌故事图标&quot;)">
                  <div class="title">
                    <h2 class="title-text">{{ $cms('c_39e2dc770204', 'f_0015', "品牌故事") }}</h2>
                    <p class="title-desc">{{ $cms('c_39e2dc770204', 'f_0016', "Brand Development") }}</p>
                  </div>
                </header>
                <p class="desc">{{ $cms('c_39e2dc770204', 'f_0017', "DiaryLuck自 2010年诞生便以精准营养科技为根基，深耕天然健康领域。我们有国际顶尖科学家组成的科研团队和美国先进的独立研发实验室，致力于用真正科学与前沿的理念配方，重建人体自愈与免疫力，为追求卓越健康品质的人群提供专业、高效且系统化的营养产品解决方案。") }}<br /><br />
                  {{ $cms('c_39e2dc770204', 'f_0018', "DiaryLuck以制药级标准践行健康承诺，将专业、严谨的医研基因带给更广泛的人群。") }}</p>
              </div>

              <img class="box-img" :src="$cms('c_39e2dc770204', 'f_0019', &quot;https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250916102203320000218.17579893230825217.jpg?x-oss-process=image/quality,Q_80&quot;)" :alt="$cms('c_39e2dc770204', 'f_0020', &quot;DiaryLuck品牌发展历程图片&quot;)">
             
            </div>
          </section>

          <section v-show="$cms('c_39e2dc770204', 'f_0021', true)" class="box-3">
            <div class="box-content">
              <img :src="$cms('c_39e2dc770204', 'f_0022', &quot;https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250915193927510000742.17579363673372700.png&quot;)" class="box-img" :alt="$cms('c_39e2dc770204', 'f_0023', &quot;DiaryLuck国际知名教授研发团队&quot;)">
              <div class="right">
                <h2 class="t1">{{ $cms('c_39e2dc770204', 'f_0024', "国际知名教授领衔研发") }}</h2>
                <p class="t2">{{ $cms('c_39e2dc770204', 'f_0025', "Renowned international professors lead the research and development") }}</p>
                <h3 class="t3">{{ $cms('c_39e2dc770204', 'f_0026', "产品实力过硬") }}</h3>
                <h4 class="t4">{{ $cms('c_39e2dc770204', 'f_0027', "专业团队背景") }}</h4>
                <p class="t5">{{ $cms('c_39e2dc770204', 'f_0028', "国际营养与制药领域泰斗级专家") }}<br />{{ $cms('c_39e2dc770204', 'f_0029', "曾任全球顶尖健康科学机构首席研究员") }}<br />{{ $cms('c_39e2dc770204', 'f_0030', "主导制定多项行业核心标准") }}</p>
              </div>
            </div>
          </section>
          
          <section v-show="$cms('c_39e2dc770204', 'f_0031', true)" class="box-4">
            <header class="box-header">
              <h2 class="box-header-title">{{ $cms('c_39e2dc770204', 'f_0032', "专业品质荣获多重国际质量认证") }}</h2>
              <p class="box-header-en-title">{{ $cms('c_39e2dc770204', 'f_0033', "Professional quality has won multiple international quality certifications.") }}</p>
            </header>
            <div class="box-content">
              <img class="box-img" :src="$cms('c_39e2dc770204', 'f_0034', &quot;https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250915193927510000811.17579363673331923.jpg?x-oss-process=image/quality,Q_80&quot;)" :alt="$cms('c_39e2dc770204', 'f_0035', &quot;DiaryLuck多重国际质量认证证书&quot;)">
            </div>
          </section>

          <section v-show="$cms('c_39e2dc770204', 'f_0036', true)" class="box-4">
            <header class="box-header">
              <h2 class="box-header-title">{{ $cms('c_39e2dc770204', 'f_0037', "以高端标准定义品质新高度") }}</h2>
              <p class="box-header-en-title">{{ $cms('c_39e2dc770204', 'f_0038', "Define a new height of quality with high-end standards") }}</p>
              <p class="box-header-desc">{{ $cms('c_39e2dc770204', 'f_0039', "世界工厂 全程严苛质控") }}</p>
            </header>
            <div class="box-content">
              <img class="box-img" :src="$cms('c_39e2dc770204', 'f_0040', &quot;https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250915193927510000563.17579363673349083.jpg?x-oss-process=image/quality,Q_80&quot;)" :alt="$cms('c_39e2dc770204', 'f_0041', &quot;DiaryLuck世界工厂生产线高端标准质控&quot;)">
            </div>
          </section>

          <section v-show="$cms('c_39e2dc770204', 'f_0042', true)" class="box-4 last-box">
            <header class="box-header">
              <h2 class="box-header-title">{{ $cms('c_39e2dc770204', 'f_0043', "美国线下药房热销") }}</h2>
              <p class="box-header-en-title">{{ $cms('c_39e2dc770204', 'f_0044', "Offline pharmacies in the United States are hot sellers") }}</p>
            </header>
            <div class="box-content">
              <img class="box-img" :src="$cms('c_39e2dc770204', 'f_0045', &quot;https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250915193927510000409.17579363673313731.jpg?x-oss-process=image/quality,Q_80&quot;)" :alt="$cms('c_39e2dc770204', 'f_0046', &quot;DiaryLuck美国线下药房热销产品展示&quot;)">
            </div>
          </section>
          <BrandCooperationBox />
        </div>
      </article>
    </main>
  </div>
</template>

<script>
import ToolsBar from '@/components/ToolsBar.vue';
import BrandCooperationBox from '@/components/brand/BrandCooperationBox.vue';

export default {
  components: {
    ToolsBar,
    BrandCooperationBox,
  },
  head() { return this.$cmsHead('c_39e2dc770204', {
    title: 'DiaryLuck-精准营养科技品牌|细胞抗衰|健康营养品|魔筷科技',
    meta: [
      {
        name: 'Keywords',
        content:
          'DiaryLuck,精准营养,细胞抗衰,健康营养品,营养补充剂,生命平衡,健康科技,美国品牌,国际质量认证,营养科学,健康管理,魔筷科技',
      },
      {
        name: 'Description',
        content:
          'DiaryLuck源自美国，专注精准营养科技24年，拥有超100项国际专利。以制药级标准提供细胞抗衰与核心机能营养解决方案，重构健康内在秩序，让稳态新生，让生命复衡。',
      },
    ],
  }); },
  data() {
    return {

    }
  },
  mounted() {
    // this.initFullpage()
    this.$refs.toolsBar.show()
  },
  methods: {
   
  },
}
</script>

<style lang="less" scoped>
@import "../../style/common.less";

.media-content {
  padding-top: 90px;
}

.service-wrapper {
  .banner-wrapper {
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    .pxToVw(height, 680);
    background-image: var(--cms-c_39e2dc770204-f_0047, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20260108151244820000772.17678563642689902.jpg?x-oss-process=image/quality,Q_80"));
    background-size: cover;
    background-repeat: no-repeat;
    h1.title {
      .pxToVw(margin-bottom, 13);
      line-height: 1.4;
      .pxToVw(font-size, 60);
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #fff;
    }
    .desc {
      .pxToVw(line-height, 33);
      .pxToVw(font-size, 24);
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fff;
    }
    .actions {
      display: flex;
      align-items: center;
      .pxToVw(margin-top, 77);
    }
  }
  .content-wrapper {
    .box-header {
      .pxToVw(padding-top, 80);
      color: #333333;
      &-title {
        margin: 0 auto 8 * @unitVw;
        .pxToVw(margin-bottom, 28);
        text-align: center;
        .pxToVw(line-height, 50);
        .pxToVw(font-size, 36);
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        position: relative;
        &::after {
          content: "";
          position: absolute;
          .pxToVw(top, 64);
          left: 50%;
          .pxToVw(width, 160);
          height: 1px;
          background: #d8d8d8;
          transform: translateX(-50%);
        }
      }
      &-en-title {
        font-weight: 500;
        .pxToVw(font-size, 18);
        .pxToVw(line-height, 26);
        text-align: center;
        .pxToVw(margin-bottom, 26);
      }
      &-desc {
        text-align: center;
        .pxToVw(line-height, 25);
        .pxToVw(font-size, 18);
        font-weight: 300;
        color: #666;
      }
    }
    
    .box-1 {
      background: #FFF;
      .box-content {
        margin: 0 auto;
        .pxToVw(margin-top, 60);
        .pxToVw(width, 1440);
        .pxToVw(height, 700);
        background-image: var(--cms-c_39e2dc770204-f_0048, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20260108151244820000843.17678563642678094.jpg"));
        background-size: cover;
        background-repeat: no-repeat;
        box-sizing: border-box;
        position: relative;
        .pxToVw(padding-top, 230);
        .pxToVw(padding-left, 80);
        .desc {
          .pxToVw(width, 600);
          font-weight: 400;
          .pxToVw(font-size, 24);
          .pxToVw(line-height, 40);
          color: #666666;
        }
      }
    }

    .box-2 {
      background: #F8F8F8;
      .pxToVw(padding-top, 80);
      .pxToVw(padding-left, 120);
      .box-content {
        background: linear-gradient( 180deg, #FFFFFF 0%, rgba(255,255,255,0) 100%);
        border-radius: 40px 0 0 40px;
        .pxToVw(padding-left, 120);
        .pxToVw(padding-bottom, 130);
        position: relative;
        display: flex;
        .box-left {
          .pxToVw(padding-top, 82);
          .title-box {
            display: flex;
            color: #FF6600;
            font-weight: 600;
            .pxToVw(line-height, 40);
            .pxToVw(margin-bottom, 26);
            .title-icon {
              display: block;
              .pxToVw(width, 48);
              .pxToVw(height, 52);
              .pxToVw(margin-right, 14);
            }
            .title-text {
              .pxToVw(font-size, 36);
            }
            .title-desc {
              .pxToVw(font-size, 24);
            }
          }
          .slogan {
            font-weight: 500;
            .pxToVw(font-size, 24);
            .pxToVw(line-height, 33);
            .pxToVw(margin-bottom, 24);
          }
          .desc {
            font-weight: 400;
            .pxToVw(font-size, 18);
            .pxToVw(line-height, 30);
            color: #666666;
            .pxToVw(width, 800);
          }
        }
        .box-img {
          display: block;
          .pxToVw(width, 520);
          .pxToVw(height, 414);
          .pxToVw(margin-left, 119);
          .pxToVw(margin-top, 170);
        }
      }
    }

    .box-3 {
      background: #F8F8F8; 
      .pxToVw(padding-bottom, 110);
      .box-content {
        border-radius: 0px 40px 40px 40px;
        background: linear-gradient( 180deg, #FFFFFF 0%, rgba(255,255,255,0) 100%);
        box-sizing: border-box;
        .pxToVw(width, 1680);
        .pxToVw(height, 680);
        position: relative;
        display: flex;
        .pxToVw(padding-top, 80);
        .pxToVw(padding-left, 360);
        .box-img {
          display: block;
          .pxToVw(width, 420);
          .pxToVw(height, 600);
          .pxToVw(margin-right, 140);
        }
        .right {
          .pxToVw(width, 626);
          .pxToVw(margin-top, 40);
          .t1 {
            font-weight: 600;
            font-size: 36px;
            color: #FF6600;
            line-height: 40px;
          }
          .t2 {
            font-weight: 600;
            font-size: 24px;
            color: #FF6600;
            line-height: 40px;
            .pxToVw(margin-bottom, 40);
          }
          .t3 {
            font-weight: 600;
            font-size: 40px;
            color: #333333;
            line-height: 56px;
          }
          .t4 {
            font-weight: 500;
            font-size: 24px;
            color: #333333;
            line-height: 33px;
            .pxToVw(margin-top, 34);
            .pxToVw(margin-bottom, 15);
          }
          .t5 {
            font-weight: 400;
            font-size: 18px;
            color: #666666;
            line-height: 42px;
          }
        }
      }
    }

    .box-4 {
      background: #FFF;
      .box-content {
        .pxToVw(padding-top, 60);

      }
      .box-img {
        display: block;
        margin: 0 auto;
        .pxToVw(width, 1200);
      }
    }

    .last-box {
      .pxToVw(padding-bottom, 168);
    }
  }
}
</style>
